import React from 'react'
import './inputRow.scss'

export default function InputRows(props) {
    const { lang } = props;
    return(
        <div className='row'>
            <label htmlFor={lang.lang + 'Name'}>{lang.nameMore}<span>*</span></label>
            <input id={lang.lang + 'Name'} type="text" placeholder={lang.name} required minLength='3' maxLength='50' />
            <label htmlFor={lang.lang + 'Description'}>{lang.descMore}<span>*</span></label>
            <textarea placeholder={ lang.description } required id={lang.lang + 'Description'} />
        </div>

    )
}